/**
 * A custom error class that indicates a form validation error.
 */
export default class ValidationError extends Error {}
